<template>
  <div
    class="message-text__wrap"
    :class="{
      'show--quoted': isQuotedContentPresent,
      'hide--quoted': !isQuotedContentPresent,
    }"
    dir="auto"
  >
    <div
      v-if="!isEmail"
      v-dompurify-html="message"
      class="text-content"
      :style="{
        textAlign: isRTLView ? 'right' : 'left',
      }"
    />
    <letter
      v-else
      class="text-content"
      :html="message"
      :style="
        emailBodyBackground ? { backgroundColor: emailBodyBackground } : {}
      "
    />
  </div>
</template>

<script>
import Letter from 'vue-letter';
import rtlMixin from 'shared/mixins/rtlMixin';

export default {
  components: { Letter },
  mixins: [rtlMixin],
  props: {
    message: {
      type: String,
      default: '',
    },
    isEmail: {
      type: Boolean,
      default: true,
    },
    displayQuotedButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showQuotedContent: false,
    };
  },
  computed: {
    isQuotedContentPresent() {
      if (!this.isEmail) {
        return this.message.includes('<blockquote');
      }
      return this.showQuotedContent;
    },
    emailBodyBackground() {
      if (!this.isEmail || !this.message) {
        return '';
      }
      try {
        const { body } = new DOMParser().parseFromString(
          this.message,
          'text/html'
        );
        return (
          body?.style.backgroundColor ||
          body?.style.background ||
          body?.getAttribute('bgcolor') ||
          ''
        );
      } catch (error) {
        return '';
      }
    },
  },
  methods: {
    toggleQuotedContent() {
      this.showQuotedContent = !this.showQuotedContent;
    },
  },
};
</script>
<style lang="scss">
// d99d
.is-video .text-content {
  padding: var(--space-micro) var(--space-small);
}
// .
:dir(rtl) {
  .text-content {
    ul,
    ol {
      padding-right: var(--space-two);
    }
    li {
      text-align: right;
    }
  }
}
.text-content {
  ul,
  ol {
    padding-left: var(--space-two);
  }
  table {
    margin: 0;
    border: 0;

    td {
      margin: 0;
      border: 0;
    }

    tr {
      border-bottom: 0 !important;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--font-size-normal);
  }
}

.show--quoted {
  blockquote {
    @apply block;
  }
}

.hide--quoted {
  blockquote {
    @apply hidden;
  }
}
</style>
